import { render, staticRenderFns } from "./SectionContainer.vue?vue&type=template&id=efadbd56"
import script from "./SectionContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./SectionContainer.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports